import CustomizeTheme from '../site/customize-theme';
export default class ColorPicker {
  constructor() {
    const pickerContainer = document.querySelectorAll('.color-container');
    if (pickerContainer.length) {
      this.pickerContainer = pickerContainer;
      this.colorOnchange();
    }
  }
  colorOnchange() {
    const pickerInputs = document.querySelectorAll('.color-input');

    if (this.pickerContainer.length) {
      this.pickerContainer.forEach( (picker) => {
        picker.addEventListener('change', (elem) => {
          picker.nextElementSibling.value = elem.target.value;

          // Update colors on preview
          const preview = new CustomizeTheme();
          preview.updatePreviewColors(picker, picker.nextElementSibling.value);
        });
      });
    }

    if (pickerInputs.length) {
      pickerInputs.forEach( (pickerInput) => {
        pickerInput.addEventListener('change', (elem) => {
          pickerInput.previousElementSibling.firstElementChild.value = elem.target.value;

          // I know, I'm sorry.
          const preview = new CustomizeTheme();
          preview.updatePreviewColors(pickerInput, pickerInput.previousElementSibling.firstElementChild.value);
        });
      });
    }
  }
}
